import axios from "axios";
import { toast } from "react-toastify";
import { API_KEY, API_URL ,IS_FAVOURITE_LOGIN, IS_TRIIVCO_LOGIN, REQUEST_RESPONSE_ENCRYPTION} from "../config/constant";
import secureStorage from "../config/encrypt";
import crypto from "crypto-browserify";
import { Buffer } from "buffer";

const instance = axios.create({
  baseURL: API_URL.COMMON_GATEWAY_API,
  headers: {}
});
instance.interceptors.request.use(
  (request) => {
    let entity_source = localStorage.getItem('entity_source') || '';
    if(!entity_source){
      entity_source = IS_FAVOURITE_LOGIN() ? 'fav-id' : IS_TRIIVCO_LOGIN() ? 'triv-id':'oto-in';
    }
    let exludeUrl = ["login_with_email","reactivate_user","login-otp","send_otp","import_bfi_loan_data","import_sinarmas_loan_data","import_refund_received","import_sms_tla","import_mmv_mpm","import_mmv_buana","import_mmv_brand_type","import_mmv_bcamf","import_insurance_rate","import_variant","import_csv","import_fid_data","logout","bulk_upload_branch" , "import_dpd","import_cri_data"];
    let urlHavingqueryString = request?.params || null,reqbody = request?.data || null;
    let UrlSplit = request.url.split("/");
    // console.log("UrlSplit",UrlSplit,"request.url",request.url,"urlHavingqueryString",urlHavingqueryString,"reqbody",reqbody,"exclude",exludeUrl.includes(UrlSplit[UrlSplit.length-1]))

    // console.log("exclude",exludeUrl.includes(UrlSplit[UrlSplit.length-1]),"Split",UrlSplit[1],"urlHavingqueryString",urlHavingqueryString,"reqbody",reqbody)
    let headers = {
      'Authorization': getToken(),
      'Accept-Language': getSelectedLanguage(),
      'source':"WEB",
      'tenant': entity_source,
      'is_encrypt_response': (exludeUrl.includes(UrlSplit[UrlSplit.length - 1]) || !['loan', 'refinance', 'bike-refinance', 'hrf'].includes(UrlSplit[1])) ? 0 : 1
    };
    if(request.apiKey) {
      headers["apiKey"] = request.apiKey;
    }
    if(request.url?.includes("/remove_user")) {
      headers["apiKey"] = API_KEY
    }
    if(!isValidUrl(entity_source,request.url)){
      window.location = '/logout';
    }
    request.headers = headers;
    if(headers?.is_encrypt_response===1 && reqbody){
      
      reqbody = hybridEncrypt(reqbody, REQUEST_RESPONSE_ENCRYPTION.public_key)
      request.data = reqbody;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    
    if(response.data?.encrypted_symmetric_key){
        let {encrypted_data, encrypted_symmetric_key, iv} = response.data; 
        let decryptedResponse = hybridDecrypt(encrypted_data, encrypted_symmetric_key, iv);
        // console.log("decryptedResponse",decryptedResponse)
        response.data = decryptedResponse;
    }
    if (response && response.data && response.data.status !== 200) {
      if (response.data.status === 400){
        toast.error(`${response.data.message}`);
        if(response.data.message === "access_token_expired")
        window.location = '/logout';
    }
  }
    if (response.status === 401) {
      window.location = '/logout';
    }
    
    return response;
  },
  (error) => {
    if (error.response && error.response.status && error.response.status === 401) {
      window.location = '/logout';
    }
    return Promise.reject(error);
  }
);
const getToken = () => {
  let fetchHeader = secureStorage.getItem("authToken");
  return fetchHeader;
}
const getSelectedLanguage = () => {
  return secureStorage.getItem("lang") || 'en'
}
const finaljson= {
  post(URL, body, headers=null) {
    return instance.post(`${URL}`, body, headers);
  },
  put(URL, body) {
    return instance.put(`${URL}`, body);
  },
  get(URL, query) {
    return instance.get(`${URL}`, { params: query });
  }
};
const isValidUrl = (entity_source,url)=>{
  let isValid=true;
  let redirecTwhenFoundUrl=["/loan/lead/getleads","/loan/lead/lead_dashboard","/loan/report/get_tat_report","/bike-refinance/finance/dashboard","/loan/report/get_funnel_report","/loan/lead/get_api_config_data","/loan/report/get_user_tat_report"]
  // console.log("entity_source",entity_source,"url",url)
  if(redirecTwhenFoundUrl.includes(url) && entity_source==='emp-id'){
    isValid=false;
  }
  return isValid;
}

const hybridEncrypt = (data, public_key) => {
  if (!data || typeof data !== 'object') {
    throw new Error('Data to encrypt must be an object.');
  }
  if (!public_key || typeof public_key !== 'string') {
    throw new Error('Public key is required and must be a PEM-formatted string.');
  }

  const symmetric_key = crypto.randomBytes(32); // 256-bit key
  const iv = crypto.randomBytes(16); // 128-bit IV

  const cipher = crypto.createCipheriv(REQUEST_RESPONSE_ENCRYPTION.aes_algo, symmetric_key, iv);
  let encrypted_data = cipher.update(JSON.stringify(data), 'utf8', 'base64');
  encrypted_data += cipher.final('base64');

  const encrypted_symmetric_key = crypto.publicEncrypt(public_key, symmetric_key).toString('base64');

  return {
    encrypted_data,
    encrypted_symmetric_key,
    iv: Buffer.from(iv).toString("base64"),
  };
};


const hybridDecrypt = (encrypted_data, encrypted_symmetric_key, iv) => {
  let decipher = crypto.createDecipheriv(REQUEST_RESPONSE_ENCRYPTION.aes_algo, REQUEST_RESPONSE_ENCRYPTION.response_aes_key, Buffer.alloc(16, 0));
  let symmetric_key = decipher.update(encrypted_symmetric_key, 'base64', 'utf8');
  symmetric_key += decipher.final('utf8');

  decipher = crypto.createDecipheriv(REQUEST_RESPONSE_ENCRYPTION.aes_algo, Buffer.from(symmetric_key, 'base64'), Buffer.from(iv, 'base64'));
  let decrypted_data = decipher.update(encrypted_data, 'base64', 'utf8');
  decrypted_data += decipher.final('utf8');

  return JSON.parse(decrypted_data);
};


export default finaljson;